import React from 'react';
import ReactDOM from 'react-dom/client';
import '@parentpath/i18n'; // Initialize i18n before rendering
import App from './App';
import './styles/index.css';
import { initNativeUI } from './lib/capacitor';

// Initialize native UI settings (adds native-app class, configures status bar)
initNativeUI();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
